import React from "react";
import { useTranslation } from "react-i18next";
import { Box } from "@mui/material";
import { useTheme } from "@mui/material/styles";
import { MyTimeWorkingFrameBox } from "my-time/components";
import { useMyTimeFramePeriod } from "my-time/hooks";

type MyTimeRemainsFrameProps = {
  contractCode: string;
  year: number;
  month: number;
  minHeight?: number | string;
};

export const MyTimeRemainsFrame: React.FC<MyTimeRemainsFrameProps> = ({
  contractCode,
  year,
  month,
  minHeight,
}) => {
  const theme = useTheme();
  const { t } = useTranslation();

  const { data, loading } = useMyTimeFramePeriod({
    contractCode,
    year: year,
    month: month,
  });

  const formatValue = (value: number) => {
    if (value % 1 !== 0) {
      const formattedValue = value?.toFixed(3);
      return formattedValue?.endsWith("00")
        ? Number.parseFloat(formattedValue)?.toFixed(1)
        : formattedValue;
    } else {
      return value?.toString();
    }
  };

  const remainderTimeFrame = data?.hoursByFact - data?.hoursByLaw;

  return (
    <Box>
      <MyTimeWorkingFrameBox
        label={t("MY_TIME_BALANCE")}
        value={formatValue(remainderTimeFrame)}
        color={theme.palette.yellowBase.main}
        loading={loading || !data}
        minHeight={minHeight}
      />
    </Box>
  );
};

export default MyTimeRemainsFrame;
